import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { MicrodataContext } from "config/contexts";

import styles from "./Headline.css";

export default function Headline({
  headline,
  seoHeadline,
  permalink,
  isPrimary,
}) {
  const Heading = isPrimary ? "h1" : "h3";
  const Wrapper =
    isPrimary || !permalink
      ? React.Fragment
      : props => <Link to={permalink} className={styles.link} {...props} />;
  return (
    <MicrodataContext.Consumer>
      {microdata => (
        <React.Fragment>
          {microdata && (
            <meta itemProp="headline" content={seoHeadline || headline} />
          )}
          <Wrapper>
            <Heading className={styles.headline}>{headline}</Heading>
          </Wrapper>
        </React.Fragment>
      )}
    </MicrodataContext.Consumer>
  );
}

Headline.propTypes = {
  headline: PropTypes.string.isRequired,
  seoHeadline: PropTypes.string,
  permalink: PropTypes.string,
  isPrimary: PropTypes.bool,
};
